export enum GridComponentType {
  ACTION = 'action',
  BADGE = 'badge',
  CHIP = 'chip',
  TEXT = 'text',
  SELECT = 'select',
  DATE = 'date',
  DATETIME = 'datetime',
  LINK = 'link',
  COMMA_SEPERATED = 'comma_separated',
  ADDRESSES = 'addresses',
  CHECKBOX = 'checkbox',
  READONLY_CHECKBOX = 'readonly_checkbox',
}

export const DEFAULT_PAGE_SIZE = 25;

/**
 * Values for the All / Pinned quick-filter chips on the Studies and Sites list pages.
 *
 * `ALL` is the default selection; `PINNED` narrows the grid to the user's pinned
 * records and is also the state the dashboard "View all pinned items" handoff
 * arrives in (via the `is_pinned=true` query param).
 */
export const GRID_PIN_TOGGLE = {
  ALL: 'all',
  PINNED: 'pinned',
} as const;

/** Union of the {@link GRID_PIN_TOGGLE} values. */
export type GridPinToggle =
  (typeof GRID_PIN_TOGGLE)[keyof typeof GRID_PIN_TOGGLE];
